import { FC, useEffect, useState } from "react";
import { MainStageWork } from "../../types/slices/mainStagesWorksType";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { useAuthStore } from "../../hooks";
import { Role } from "../../types/roles/roleTypes";
import { useMainStagesWorksStore } from "../../hooks/useMainStagesWorks";
import { WorkDone } from "../../types/slices/workDondeType";

const MainStagesWorksList: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { search } = useSelector(selectHeaderState)
    const { status, mainStagesWorks, getMainStagesWorks, deleteMainStagesWorksStore, setSelectedMainStagesWorks } = useMainStagesWorksStore();

    const [loading, setLoading] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)
    const [rowSelected, setRowSelected] = useState<MainStageWork>({} as MainStageWork)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const userRole: Role | any = user.userType

    const columns = [
        { type: 'options', field: 'options', label: 'OPCIONES', align: 'center' },
        { type: 'text', field: 'actions', label: 'ACCIONES', align: 'center' },
        { type: 'text', field: 'works_dones', label: 'ACTIVIDADES', align: 'center', format: (row) => row.works_dones?.map((element) => element).join(' - ') },
        { type: 'detail', field: 'detail', label: '', align: 'center' },
    ]

    useEffect(() => {
        getMainStagesWorksApi()
    }, [search])

    const getMainStagesWorksApi = async () => {
        try {
            setLoading(true)
            let payload: any = {}
            if (search !== '') {
                payload = {
                    ...payload,
                    actions: search
                }
            }
            await getMainStagesWorks(payload)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const onAdd = () => {
        setSelectedMainStagesWorks({} as MainStageWork)
        navigate({ pathname: RoutesMap.MAIN_STAGES_WORKS_FORM })
    }

    const onEdit = (rowSelected) => {
        setSelectedMainStagesWorks(rowSelected)
        navigate({ pathname: RoutesMap.MAIN_STAGES_WORKS_FORM })
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async () => {
        const response = await deleteMainStagesWorksStore(rowSelected.id)
        if (response === true) {
            setSelectedMainStagesWorks({} as MainStageWork)
            setShowModalConfirm(false)
            getMainStagesWorksApi()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <>
            <Grid item xs={12}>
                {userRole === Role.ADMIN && (
                    <CustomTable
                        title={'Etapas principales de trabajo'}
                        columns={columns || []}
                        loading={loading}
                        rows={mainStagesWorks || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
                {userRole === Role.MAINTENANCE && (
                    <CustomTable
                        title={'Etapas principales de trabajo'}
                        columns={columns || []}
                        loading={loading}
                        rows={mainStagesWorks || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
            </Grid>
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onDeleteConfirm}
                        status2={status === ApiStatus.FETCHING ? true : false}
                    />
                )
            }
        </>
    )
}

export default MainStagesWorksList

